import { PropertyValue } from "src/types/property";

export const getPropertyValueByCode = (
  properties: PropertyValue[],
  code: string
): PropertyValue | null => {
  return properties.find((property) => property.property.code === code) ?? null;
};
